import React, { useState } from 'react';
import { Container, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TextDecrypt } from '../content/TextDecrypt';
import './Contact.css';

const useStyles = makeStyles((theme) => ({
  main: {
    width: '100%',
    padding: theme.spacing(4, 0),
  },
  form: {
    width: '100%',
  },
  formField: {
    width: '100%',
    marginBottom: theme.spacing(3),
    '& .MuiFilledInput-root': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
    '& .MuiFilledInput-root:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.12)',
    },
  },
}));

export const Contact = () => {
  const classes = useStyles();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, message } = formData;
    const subject = `Message from ${encodeURIComponent(name)}`;
    const body = `Name: ${encodeURIComponent(name)}%0AEmail: ${encodeURIComponent(email)}%0A%0A${encodeURIComponent(message)}`;
    window.location.href = `mailto:hello@jobinabraham.me?subject=${subject}&body=${body}`;
  };

  return (
    <section id="contact">
      <Container component="main" className={classes.main} maxWidth={false}>
        <div className="contact">
          <h1 className="contact_msg">
            <TextDecrypt text="Say hello. 👋🏼" />
          </h1>
          
          <div className="_form_wrapper">
            <form onSubmit={handleSubmit} className={classes.form}>
              <TextField
                name="name"
                label="Name"
                variant="filled"
                className={classes.formField}
                value={formData.name}
                onChange={handleInputChange}
                required
              />
              
              <TextField
                name="email"
                label="Email"
                type="email"
                variant="filled"
                className={classes.formField}
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              
              <TextField
                name="message"
                label="Hey Jobin!"
                variant="filled"
                multiline
                minRows={5}
                className={classes.formField}
                value={formData.message}
                onChange={handleInputChange}
                required
              />
              
              <button type="submit" className="submit-btn">
                <i className="fas fa-terminal"></i>
                <span>SEND</span>
              </button>
            </form>
          </div>
        </div>
      </Container>
    </section>
  );
};
